import { FORAGE_BRAINS, FORAGE_CONTROLS } from './forageConfig';

function Slider({ control, value, onChange }) {
    const { key, label, min, max, step, format } = control;
    return (
        <label className="forage-control" htmlFor={`forage-${key}`}>
            <span>
                <span>{label}</span>
                <output htmlFor={`forage-${key}`}>{format(value)}</output>
            </span>
            <input
                id={`forage-${key}`}
                aria-label={label}
                type="range"
                min={min}
                max={max}
                step={step}
                value={value}
                onChange={(event) => onChange(key, event.target.value)}
            />
        </label>
    );
}

function ForageControls({ config, paused, onChange, onPause, onReset, onNewWorld }) {
    return (
        <aside className="forage-controls">
            <div className="forage-controls-heading">
                <div>
                    <p>Learning variables</p>
                    <span>Changing a variable starts a new training run.</span>
                </div>
                <button type="button" onClick={onReset}>Reset</button>
            </div>

            <fieldset className="forage-brain-picker">
                <legend>Brain</legend>
                {FORAGE_BRAINS.map((brain) => (
                    <button
                        key={brain.id}
                        type="button"
                        className={config.brain === brain.id ? 'is-active' : ''}
                        aria-pressed={config.brain === brain.id}
                        onClick={() => onChange('brain', brain.id)}
                    >
                        <strong>{brain.name}</strong>
                        <span>{brain.description}</span>
                        <small>{brain.architecture}</small>
                    </button>
                ))}
            </fieldset>

            <div className="forage-control-list">
                {FORAGE_CONTROLS.map((control) => (
                    <Slider
                        key={control.key}
                        control={control}
                        value={config[control.key]}
                        onChange={onChange}
                    />
                ))}
            </div>

            <label className="forage-control forage-speed" htmlFor="forage-trainingRate">
                <span>
                    <span>Training speed</span>
                    <output htmlFor="forage-trainingRate">{config.trainingRate}×</output>
                </span>
                <input
                    id="forage-trainingRate"
                    aria-label="Training speed"
                    type="range"
                    min="1"
                    max="5"
                    step="1"
                    value={config.trainingRate}
                    onChange={(event) => onChange('trainingRate', event.target.value)}
                />
            </label>

            <div className="forage-actions">
                <button type="button" className="forage-primary-action" onClick={onPause}>
                    {paused ? 'Start learning' : 'Pause learning'}
                </button>
                <button type="button" onClick={onNewWorld}>New seed</button>
            </div>
        </aside>
    );
}

export default ForageControls;
